import React from "react";
import { DialogActions, DialogContent, DialogTitle, FormControlLabel, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { useDialog } from "../components/Dialogs/DialogProvider";

export default (props) => {
  const [, closeDialog] = useDialog();
  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          props.onSubmit(e.target[0].value);
        }}
      >
        <DialogTitle>Create Folder</DialogTitle>
        <DialogContent>
          <FormControlLabel control={<TextField />} label={"Name"} labelPlacement={"start"} />
        </DialogContent>
        <DialogActions>
          <Button
            variant={"outlined"}
            color={"secondary"}
            onClick={() => {
              closeDialog();
            }}
          >
            Cancel
          </Button>
          <Button variant={"outlined"} color={"primary"} type={"submit"}>
            Upload
          </Button>
        </DialogActions>
      </form>
    </>
  );
};
